import util from '@bmp-vue/core/api/util'
const controller = 'Correios'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  PesquisaCorreios: function (endereco) {
    return util.Axios.Post(controller + '/PesquisaCorreios', { endereco })
  }
})
